// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3V1zu","amount":"Amount_amount__3rhJ5","tip":"Amount_tip__JOB06","tipHeader":"Amount_tipHeader__kJhkb","tipsWrap":"Amount_tipsWrap__2fMYv"};